import React from 'react';

import type { Row } from 'react-table';

import type { SummaryDetailsTranslation } from '../../../components/routes-planner/translations';
import { NO_ROUTE_ID } from '../../../stores/routes-planner-store';
import type { RoutesPlannerTask } from '../../../types';
import ColumnSelection from '../column-selection/column-selection';

import './summary-details.scss';

interface ISummaryDetailsProps {
	rows: Row<RoutesPlannerTask>[];
	tasksCount: number;
	driversCount: number;
	routesCount: number;
	vehicles: {
		enabled: boolean;
		count?: number;
	};
	translations: SummaryDetailsTranslation;
}

const SummaryDetails: React.FC<ISummaryDetailsProps> = props => {
	const { rows, tasksCount, driversCount, routesCount, vehicles, translations } = props;

	const countUnassignedTasks = () => {
		const unassignedTaskObject = rows.find(row => {
			return row.groupByVal === String(NO_ROUTE_ID);
		});

		return unassignedTaskObject ? unassignedTaskObject.leafRows.length : 0;
	};

	const unassignedTasksCount = countUnassignedTasks();

	return (
		<div className="summary-details">
			<div className="summary-section">
				<span className="summary-data tasks-count">
					{tasksCount} {translations.totalOrders}:
				</span>
				<span className="summary-data tasks-assigned">
					{tasksCount - unassignedTasksCount} {translations.assigned},
				</span>
				<span className="summary-data tasks-unassigned">
					{unassignedTasksCount} {translations.unassigned}
				</span>
			</div>
			<div className="summary-section">
				<span className="summary-data drivers-count">
					{driversCount} {translations.drivers}
				</span>
				<span className="summary-data routes-count">
					{routesCount} {translations.routes}
				</span>
				{vehicles.enabled && (
					<span className="summary-data vehicles-count">
						{vehicles.count} {translations.vehicles}
					</span>
				)}

				<ColumnSelection />
			</div>
		</div>
	);
};

export default SummaryDetails;
